export function substituteCommand(cmd: string, env: NodeJS.ProcessEnv): string {
  return cmd.replace(/\$\{([^}]+)\}/g, (_, key: string) => (env[key] != null ? String(env[key]) : ''));
}

/** Plain string env only — avoids spawn issues from non-string `process.env` values. */
export function envForSpawn(
  base: NodeJS.ProcessEnv,
  userEnv: Array<{ name: string; value: string }>,
  ports: number[],
): NodeJS.ProcessEnv {
  const userKeys = new Set(
    userEnv.map((e) => e.name.trim()).filter((name): name is string => Boolean(name)),
  );
  const out: NodeJS.ProcessEnv = {};
  for (const key of Object.keys(base)) {
    const v = base[key];
    if (typeof v === 'string') {
      out[key] = v;
    }
  }
  for (const { name, value } of userEnv) {
    if (name) out[name] = value;
  }
  ports.forEach((p, i) => {
    out[`PORT.${i}`] = String(p);
  });
  if (ports.length > 0) {
    out.PORTS = ports.join(',');
    if (!userKeys.has('PORT')) {
      out.PORT = String(ports[0]);
    }
  }
  // Child is usually not a TTY (piped / file / script redirect). Keep ANSI in output for log viewers.
  // Do not inherit NO_COLOR from the bridge shell unless this preview environment defines it explicitly.
  if (!userKeys.has('NO_COLOR')) {
    delete out.NO_COLOR;
  }
  if (out.FORCE_COLOR === undefined) {
    out.FORCE_COLOR = '1';
  }
  if (out.CLICOLOR_FORCE === undefined) {
    out.CLICOLOR_FORCE = '1';
  }
  return out;
}
